import { cn } from '~/lib/cn';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export function HeaderSmall({ className, children }: Props) {
  return (
    <h6
      className={cn(
        'mb-md text-headline-sm font-semibold leading-tight',
        className,
      )}
    >
      {children}
    </h6>
  );
}

HeaderSmall.displayName = 'HeaderSmall';
